import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Data Analytics Foundations & Business Understanding",
    description:
      "About  Data Analytics &  it's uses, Types of analytics: Descriptive Diagnostic Predictive Prescriptive, Understanding business problems & KPIs, Data-driven decision-making process, Real-world case studies from industries",
  },
  {
    title: "Excel Mastery for Data Analysis",
    description:
      "Excel formulas & functions (VLOOKUP IF SUMIF INDEX-MATCH), Pivot tables charts & dashboards, Data cleaning & formatting techniques, Sorting filtering & advanced Excel shortcuts, Practical business problem solving using Excel",
  },
  {
    title: "SQL for Data Querying & Database Operations",
    description:
      "Understanding databases & tables, SELECT JOIN GROUP BY ORDER BY, Aggregations & filtering data, Subqueries & CTEs, Real project-based SQL data extraction",
  },
  {
    title: "Python for Data Analytics & Automation",
    description:
      "Python basics for analysts, Pandas for data cleaning, NumPy for calculations, Matplotlib & Seaborn for visualizations, Automating repetitive analytical tasks",
  },
  {
    title: "Data Cleaning, Preparation & Transformation Techniques",
    description:
      "Handling missing values & outliers, Data standardization & normalization, Encoding categorical variables, Combining & transforming datasets, Data quality checks & validation",
  },
  {
    title: "Exploratory Data Analysis (EDA) & Insight Extraction",
    description:
      "Understanding patterns trends & correlations, Identifying anomalies & hidden patterns, Visual storytelling through charts, EDA using Python & Excel, Making insights easy to understand for business",
  },
  {
    title: "Visualization & Business Intelligence with Power BI & Tableau",
    description:
      "Building dashboards in Power BI, Creating interactive visuals & reports, Tableau charts filters & calculated fields, Connecting datasets & publishing dashboards, Converting data into business insights",
  },
  {
    title: "Statistics for Analytics & Decision Making",
    description:
      "Mean median mode variance standard deviation, Probability basics & distributions, Hypothesis testing (t-test chi-square), Correlation vs causation, Understanding insights through statistical evidence",
  },
  {
    title: "Reporting, Storytelling & Presenting Insights",
    description:
      "Designing professional reports, Turning raw data into meaningful stories, Communicating insights to non-technical teams, Creating slides for management, Real-world stakeholder presentation skills",
  },
  {
    title: "Capstone Analytics Project & Career Launchpad",
    description:
      "End-to-end analytics project (data → insights → dashboard), Industry dataset analysis, Resume building for Data Analyst roles, GitHub project portfolio creation, Interview prep for Data Analyst BI Analyst & Reporting Analyst",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
